<template>
    <div class="app-container" v-loading="isShowloading">

        <div class="panel panel-default">
            <div class="panel-body">
                <div class="form-group">
                    <div class="col-sm-3">
                        <div class="input-group">
                            <div class="input-group-addon">时间</div>
                            <input type="text" id="normalStartTime" name="normalStartTime" v-model="ruleForm.normalStartTime" class="form-control" >
                            <input type="text" id="normalEndTime" name="normalEndTime" v-model="ruleForm.normalEndTime" class="form-control" >
                        </div>
                    </div>

                    <div class="col-sm-3">
                        <div class="input-group">
                            <div class="input-group-addon">用户属性</div>
                            <select name="userType" class="form-control" v-model="ruleForm.userType">
                                <option :value="key" v-for="(val,key) in select.attribute">{{ val }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="col-sm-3">
                        <div class="input-group">
                            <div class="input-group-addon">用户性别</div>
                            <select name="userGender" class="form-control" v-model="ruleForm.userGender">
                                <option value="0">所有</option>
                                <option value="1">男性</option>
                                <option value="2">女性</option>
                            </select>
                        </div>
                    </div>

                    <div class="col-sm-3">
                        <div class="input-group">
                            <div class="input-group-addon">操作系统</div>
                            <select name="system" class="form-control" v-model="ruleForm.system">
                                <option :value="key" v-for="(val,key) in select.system">{{ val }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="col-sm-3">
                        <div class="input-group">
                            <div class="input-group-addon">安装包来源</div>
                            <select name="channel" class="form-control" v-model="ruleForm.channel">
                                <option :value="value" v-for="(key,value) in select.market">{{ key }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="col-sm-3">
                        <div class="input-group">
                            <div class="input-group-addon">马甲包类型</div>
                            <select name="majia" class="form-control" v-model="ruleForm.majia">
                                <option :value="value" v-for="(key,value) in select.majia">{{ key }}</option>
                            </select>
                        </div>
                    </div>

                </div>
                <div style="clear: both;"></div>
                <div class="form-group" style="margin-top: 20px">
                    <div class="col-sm-3">
                        <div class="input-group">
                            <div class="input-group-addon">充值金额</div>
                            <input type="text"  name="rechargeValue" v-model="ruleForm.rechargeValue" class="form-control" >
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <div class="col-sm-1 ">
                        <button type="submit"  class="btn btn-info" data-link=""
                                @click="search()" @keydown.enter.native="search()">查询</button>
                    </div>
                </div>
            </div>
        </div>

        <table class="table">
            <thead>
            <tr style="background: #e9e9e9;">
                <th :style="style1">充值时间</th>
                <th :style="style"><p>全部|聊币|VIP</p>总充值金额</th>
                <th :style="style">总人数</th>
                <th :style="style"><p>全部|聊币|VIP</p>充值用户</th>
                <th :style="style"><p>全部|聊币|VIP</p>总充值率</th>
                <th :style="style"><p>全部|聊币|VIP</p>总人均充值额</th>
                <th :style="style"><p>全部|聊币|VIP</p>总充值次数</th>
                <th :style="style"><p>全部|聊币|VIP</p>人均充值金额</th>
                <th :style="style"><p>全部|聊币|VIP</p>单笔充值金额</th>
                <th :style="style"><p>全部|聊币|VIP</p>人均充值次数</th>
            </tr>
            <tr v-if="total" style="background: #e9e9e9">
                <th>{{ total.date }}</th>
                <th :style="styles">{{ total.rechargeAmount }} | {{ total.jobAmount }} | {{ total.vipAmount }}</th>
                <th :style="styles">{{ total.nums }}</th>
                <th :style="styles">{{ total.rechargeNums }} | {{ total.jNums }} | {{ total.vNums }}</th>
                <th :style="styles">{{ total.rechargeNumsAll }}% | {{ total.jobNumsAll }}% | {{ total.vipNumsAll }}%</th>
                <th :style="styles">{{ total.rechargeAmountAll }} | {{ total.jobNumsAverage }} | {{ total.vipNumsAverage }}</th>
                <td :style="styles">{{ total.rechargeCount }} | {{ total.jobNums }} | {{ total.vipNums }}</td>
                <th :style="styles">{{ total.averageNumAmount }} | {{ total.jobNumAmount }} | {{ total.vipNumAmount }}</th>
                <th :style="styles">{{ total.averageAmount }} | {{ total.jobAverageAmount }} | {{ total.vipAverageAmount }}</th>
                <th :style="styles">{{ total.averageNum }} | {{ total.jobNum }} | {{ total.vipNum }}</th>
            </tr>

            </thead>
            <tbody v-if="data.total">
            <tr v-for="val in data.pageData">
                <td>{{ val.date }}</td>
                <td :style="styles">{{ val.rechargeAmount }} | {{ val.jobAmount }} | {{ val.vipAmount }}</td>
                <td :style="styles">{{ val.nums }}</td>
                <td :style="styles">{{ val.rechargeNums }} | {{ val.jNums }}  | {{ val.vNums }}</td>
                <th :style="styles">{{ val.rechargeNumsAll }}% | {{ val.jobNumsAll }}% | {{ val.vipNumsAll }}%</th>
                <th :style="styles">{{ val.rechargeAmountAll }} | {{ val.jobNumsAverage }} | {{ val.vipNumsAverage }}</th>
                <td :style="styles">{{ val.rechargeCount }} | {{ val.jobNums }} | {{ val.vipNums }}</td>
                <td :style="styles">{{ val.averageNumAmount }} | {{ val.jobNumAmount }} | {{ val.vipNumAmount }}</td>
                <td :style="styles">{{ val.averageAmount }} | {{ val.jobAverageAmount }} | {{ val.vipAverageAmount }}</td>
                <td :style="styles">{{ val.averageNum }} | {{ val.jobNum }} | {{ val.vipNum }}</td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr style="background: #fff; width: 100%;text-align: center">
                <td>
                    <span style="color: #D0D0D0;font-size: 30px;font-weight: bold;">暂无数据</span>
                </td>
            </tr>
            </tbody>
        </table>

        <div v-if="data.total > data.pageSize" class="pagination">
            <el-pagination background @current-change="handleCurrentChange" layout="prev, pager, next" :total="data.total" :page-size="data.pageSize">
            </el-pagination>
        </div>

    </div>
</template>

<script>
    import '@/assets/css/bootstrap.css';
    import laydate from 'layui-laydate';
    import api from "@/api/api";
    export default {
        name: "rechargeDaily",
        data() {
            return {
                total: [],
                data: {
                    currentPage: 1,
                    pageSize: 30,
                    total: 0,
                    pageData: []
                },
                select: {
                    market: [],
                    majia: [],
                    attribute: [],
                    system: []
                },
                ruleForm: {
                    page: 1,
                    normalStartTime: '',
                    normalEndTime: '',
                    userType: 0,
                    userGender: 0,
                    system: 0,
                    channel: 0,
                    majia: 0,
                    rechargeValue: ''
                },
                isShowloading: false,
                style: 'line-height: 10px;text-align: center',
                style1: 'line-height: 10px;',
                styles: 'text-align: center'
            }
        },
        mounted() {
            this.queryData();
            this.mylaydate();
        },
        methods: {
            mylaydate() {
                const _this = this;
                laydate.render({
                    elem: '#normalStartTime',
                    type: 'datetime',
                    done(value) {
                        _this.ruleForm.normalStartTime = value;
                    },
                });
                laydate.render({
                    elem: '#normalEndTime',
                    type: 'datetime',
                    done(value) {
                        _this.ruleForm.normalEndTime = value;
                    },
                });
            },
            queryData() {
                api.getRechargeDaily().then((res) => {
                    this.total = res.data.data.total;
                    this.data = res.data.data.data;
                    this.ruleForm = res.data.data.args;
                    this.select = res.data.data.select;
                });
            },
            search() {
                this.isShowloading = true;
                if (this.ruleForm) {
                    api.getRechargeDaily(this.ruleForm).then((res) => {
                        if (res.data.code) {
                            this.isShowloading = false;
                            this.$message.error(res.data.msg);
                        } else {
                            this.isShowloading = false;
                            this.data = res.data.data.data;
                            this.total = res.data.data.total;
                            this.$message.success('查询已完成！')
                        }
                    });
                }
            },
            handleCurrentChange(val) {
                this.isShowloading = true;
                this.ruleForm.page = val;
                api.getRechargeDaily(this.ruleForm).then((res) => {
                    this.isShowloading = false;
                    this.data = res.data.data.data;
                    this.itemkey = Math.random();
                });
            }
        },
        created() {
            let self = this;
            document.onkeydown = function(e) {
                let key = window.event.keyCode;
                if (key === 13) {
                    self.search();
                }
            }
        },
        beforeDestroy() {
            document.onkeydown = function (e) {
                let key = window.event.keyCode;
                if (key === 13) {
                }
            }
        }
    }
</script>

<style scoped>
    input[type=checkbox], input[type=radio] {
        margin: 0px;
    }
    .form-group {
        margin: 10px 0;
    }
    .table {
        text-align: left;
    }
    .table .tr th {
        text-align: center;
    }
    .table tr th p {
        font-size: 10px;
        color: #5e5e5e;
    }
</style>
